import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Calendar = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      fill={'none'}
    >
      <path
        d="M5.83594 1.33331V3.33331"
        stroke="var(--grey-1)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={'none'}
      />
      <path
        d="M11.1641 1.33331V3.33331"
        stroke="var(--grey-1)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={'none'}
      />
      <path
        d="M2.83594 6.06H14.1693"
        stroke="var(--grey-1)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={'none'}
      />
      <path
        d="M14.5 5.66665V11.3333C14.5 13.3333 13.5 14.6666 11.1667 14.6666H5.83333C3.5 14.6666 2.5 13.3333 2.5 11.3333V5.66665C2.5 3.66665 3.5 2.33331 5.83333 2.33331H11.1667C13.5 2.33331 14.5 3.66665 14.5 5.66665Z"
        stroke="var(--grey-1)"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={'none'}
      />
      <path
        d="M8.49373 9.13332H8.49972"
        stroke="var(--grey-1)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={'none'}
      />
      <path
        d="M6.0328 9.13332H6.03878"
        stroke="var(--grey-1)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={'none'}
      />
      <path
        d="M6.0328 11.1333H6.03878"
        stroke="var(--grey-1)"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill={'none'}
        strokeLinejoin="round"
      />
    </svg>
  );
};

Calendar.displayName = 'Calendar';
